import React, { useEffect } from 'react';

import {
  Pagination,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const Pager = ({ currentPage, setCurrentPage, totalPages }) => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [currentPage]);

  return (
    <Pagination
      totalPages={totalPages}
      setCurrentPage={setCurrentPage}
      currentPage={currentPage}
      pageRangeDisplayed={totalPages > 6 ? 2 : 5}
      marginPagesDisplayed={totalPages > 6 ? 1 : 0}
      selectPage={setCurrentPage}
      previousLabel={<div className="Pagination__previous"><i className="icon-before icon-arrow-right icon-variant-4" /><span>Vorige</span></div>}
      nextLabel={<div className="Pagination__next"><span>Volgende</span><i className="icon-after icon-arrow-right icon-variant-4" /></div>}
      controlled
    />
  );

};
export default Pager;
